'use strict';

var _ = require('lodash');
var MappedFaresGridService = function MappedFaresGridService(configurationService, overridesKeyService, overridesSaveService, scenarioConstants) {
  var domain = 'MarketClassPOSMappedFare';
  function getClassesFromRows(rows) {
    var classes = {};
    rows.reduce(function (previous, current) {
      classes[current.className] = true;
    }, undefined);
    classes = Object.keys(classes);
    return classes;
  }
  function save(data) {
    var overrides = [];
    data.forEach(function (row) {
      row.userMappedFare = isNaN(row.userMappedFare) ? 0 : row.userMappedFare;
      var overrideKey = overridesKeyService.buildOverrideKey(domain, row);
      var override = _.extend({
        field: 'fare',
        type: 'O',
        value: row.userMappedFare
      }, overrideKey);
      overrides.push(override);
    });
    return overridesSaveService.putOverrides(domain, {
      userId: configurationService.getUserId(),
      scenario: scenarioConstants.PUBLISHED,
      overrides: overrides
    });
  }
  return {
    getClassesFromRows: getClassesFromRows,
    save: save
  };
};
MappedFaresGridService.$inject = ['ConfigurationService', 'OverridesKeyService', 'OverridesSaveService', 'ScenarioConstants'];
module.exports = MappedFaresGridService;